import { useLang } from "@/i18n";
import { IMG } from "@/data/media";
import { PageHero } from "@/components/PageHero";
import { ProjectCards } from "@/components/ProjectCards";
import { SupportCta } from "@/components/SupportCta";

export default function Projects() {
  const { t } = useLang();
  const p = t.projects;
  return (
    <>
      <PageHero eyebrow={p.eyebrow} lines={p.titleLines} intro={p.intro} image={IMG.drafting} imageAlt={t.gallery.captions.drafting} corner="bl" accent="var(--blue)" />
      <section className="pb-20 sm:pb-28" data-testid="projects-list">
        <div className="wrap"><ProjectCards /></div>
      </section>
      <SupportCta />
    </>
  );
}
